import { Component, Inject, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Form, FormCategory, ModalFormCatData, ModalFormData, StateVM } from '../../../perform-induction/perform-induction';
import { SafetyInductionService } from '../../../services/safety-induction.service';
import { FileReaderEvent } from '../../../setup-implement/setup-implement.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
  EditForm: boolean;
  Form: Form,
  FormCategory: FormCategory,
  States: StateVM[]
}

export class DialogResponse {
  type: number;
  stateId: number;
  CatId:number
}

@Component({
  selector: 'app-dialog-add-form',
  templateUrl: './dialog-add-form.component.html',
  styleUrls: ['./dialog-add-form.component.scss']
})
export class DialogAddFormComponent implements OnInit {

  constructor(
    private _sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<DialogAddFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private _inductionService: SafetyInductionService,
  ) { }


  SelectType: string = '0';
  ShowFormAdd: boolean = false
  EditForm: boolean = false;
  Description: string = "";
  Name: string = "";
  Filename: string = "";
  FilePreview: string = "";
  NewFileName: string = "";
  State: string = null;

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmitClick(): void {
    console.log("this.SelectType", this.SelectType)



    if (this.SelectType == '1') {

     // if (this.ShowFormAdd && this.State != null && this.Name) {
       
      if (this.ShowFormAdd  && this.Name) {
     let _form = new ModalFormData();
        _form.formName = this.Name;
        _form.formDesc = this.Description;
        _form.categoryID = this.data.FormCategory.ID
        _form.fileName = this.NewFileName;
        _form.StateId = this.State ?Number(this.State):null

        if (this.FilePreview) {

          var sImageUrl = this.FilePreview.replace(/^data:image\/[a-z]+;base64,/, "");
          sImageUrl = this.FilePreview.replace(/^data:image\/\w+;base64,/, "");
          _form.formData = this.FilePreview
        }
        this._inductionService.CreateForm(_form).subscribe(res => {
          if (res) {
            let response=new DialogResponse();
            response.type = 1;
            response.stateId =this.State? Number(this.State):null;
            this.dialogRef.close(response);
          }
        })
      } else {
        this.ShowFormAdd = true
      }

    } else if (this.SelectType == '2') {
      let _form = new ModalFormData();
      _form.categoryID = this.data.FormCategory.ID
      _form.StateId = this.State? Number(this.State):null;


      this._inductionService.CreateDigitalForm(_form).subscribe(res => {
        if (res) {
          let response=new DialogResponse();
          response.type = 2;
          response.CatId = res;
          response.stateId = this.State? Number(this.State):null;
          this.dialogRef.close(response);
        }
      })


    }

    //this.dialogRef.close(this.SelectType);


  }

  onFileChanged(event) {


    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]); // read file as data url

      console.log("event.target.files[0]", event.target.files[0])
      this.NewFileName = event.target.files[0].name
      //reader.onload = (event: FileReaderEvent) => { // called once readAsDataURL is completed
      reader.onload = (event: any) => { // called once readAsDataURL is completed
        var fileUrl = (event.target["result"]);
        this.FilePreview = fileUrl;

      }
    }

  }

}
